import * as requestFromServer from "./commonCrud";
import {
  accountSlice,
  appSlice,
  appsSlice,
  categoriesSlice,
  searchSlice,
  settingsSlice,
} from "./commonSlice";
import * as auth from "./authRedux";

export const fetchApp = queryParams => dispatch => {
  dispatch(appSlice.actions.startCall());
  return requestFromServer
    .getApp(queryParams)
    .then(response => {
      const { data } = response.data;
      dispatch(appSlice.actions.appFetched({ data }));
    })
    .catch(error => {
      error.clientMessage = "Can't fetch data";
      dispatch(appSlice.actions.catchError({ error }));
    });
};

export const fetchApps = (queryParams, silent = false) => dispatch => {
  dispatch((silent) ? appsSlice.actions.startCallMore() : appsSlice.actions.startCall());
  return requestFromServer
    .getApps(queryParams)
    .then(response => {
      const { data } = response.data;
      dispatch(appsSlice.actions.appsFetched({ data }));
    })
    .catch(error => {
      error.clientMessage = "Can't fetch data";
      dispatch(appsSlice.actions.catchError({ error }));
    });
};

export const fetchCategories = queryParams => dispatch => {
  dispatch(categoriesSlice.actions.startCall());
  return requestFromServer
    .getCategories(queryParams)
    .then(response => {
      const { data } = response.data;
      dispatch(categoriesSlice.actions.categoriesFetched({ data }));
    })
    .catch(error => {
      error.clientMessage = "Can't fetch data";
      dispatch(categoriesSlice.actions.catchError({ error }));
    });
};

export const fetchAccount = queryParams => dispatch => {
  dispatch(accountSlice.actions.startCall());
  return requestFromServer
    .getAccount(queryParams)
    .then(response => {
      const { data } = response.data;
      dispatch(accountSlice.actions.accountFetched({ data }));
    })
    .catch(error => {
      error.clientMessage = "Can't fetch data";
      dispatch(accountSlice.actions.catchError({ error }));
    });
};

export const fetchSettings = queryParams => dispatch => {
  dispatch(settingsSlice.actions.startCall());
  return requestFromServer
    .getSettings(queryParams)
    .then(response => {
      const { data } = response.data;
      dispatch(settingsSlice.actions.settingsFetched({ data }));
    })
    .catch(error => {
      error.clientMessage = "Can't fetch data";
      dispatch(settingsSlice.actions.catchError({ error }));
    });
};

export const checkToken = queryParams => dispatch => {
  return requestFromServer
    .checkToken(queryParams)
    .then(response => {
      const { response_code } = response.data;
      if (response_code !== 1) dispatch(auth.actions.logout());
    })
    .catch(error => {
      error.clientMessage = "Can't check token";
      dispatch(auth.actions.logout());
    });
};

export const search = (queryParams, silent = false) => dispatch => {
  dispatch((silent) ? searchSlice.actions.startCallMore() : searchSlice.actions.startCall());
  return requestFromServer
    .search(queryParams)
    .then(response => {
      const { data } = response.data;
      dispatch(searchSlice.actions.dataFetched({ data }));
    })
    .catch(error => {
      error.clientMessage = "Can't fetch data";
      dispatch(searchSlice.actions.catchError({ error }));
    });
};